<template>

<avue-form v-model="form"  :defaults.sync="defaults" :option="option" @submit="submit"></avue-form>

</template>

<script>
import {  getModelDetail,editModelObj} from '@/page/modelManage/api/model'
export default {
  props: ['modelId'],
  data () {

    return {
      form: {},
      defaults:{},
      option: {
        emptyBtn:false,
        column: [
          {
            label: 'TID',
            prop: 'tid',
            rules: [{
              required: true,
              message: "请输入TID",
              trigger: "blur"
            }]
          },
          {
            label: '名称',
            prop: 'name',
            rules: [{
              required: true,
              message: "请输入名称",
              trigger: "blur"
            }]
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            minRows:3,
            maxRows:5
          }
        ]
      }
    }
  },
  mounted(){
    this.getInfo()
  },

  watch: {
    modelId(val) {
      if (val) {
        this.getInfo()
      }
    },
  },
  created () {
  },
  methods: {
    submit(form,done){
      editModelObj(form).then(res=>{
        if(res.data.success){
          this.$message.success("模型修改成功");
          this.$emit("submitSave")
        }
      })
      done();
    },
    getInfo(){
      getModelDetail(this.modelId).then(res=>{
        if(res.data.success){
          
          this.form = res.data.data
          console.log(this.form)
          // this.defaults.tid.disabled=true
          if (this.form.data_inputed==0) {
             this.defaults.tid.disabled=true
          }else{
            this.defaults.tid.disabled=false
          }
        }else{
          this.form = {}
          this.defaults.tid.disabled=false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>